/**
 * Chat → create-form draft handoff.
 *
 * The chat widget stashes a server-validated draft payload in sessionStorage
 * at CTA-click time and navigates to the create page, which consumes it on
 * mount. Consume-on-read + a short TTL means a page refresh after application
 * never re-applies the draft over user edits. Per-tab by design (the
 * navigation happens in the same tab).
 *
 * The payload is server-validated (whitelist Pydantic) before it ever reaches
 * the widget, and the page-side mapper allowlist re-filters it — sessionStorage
 * is just transport, not trust.
 */

const KEY_PREFIX = 'saarv.ai.prefill.';
const TTL_MS = 10 * 60 * 1000;

export function stashDraft(module, payload) {
  try {
    sessionStorage.setItem(
      `${KEY_PREFIX}${module}`,
      JSON.stringify({ ...payload, stashed_at: Date.now() })
    );
  } catch (e) {
    // Storage full/blocked — the CTA simply lands on an empty form.
  }
}

export function consumeDraft(module) {
  const key = `${KEY_PREFIX}${module}`;
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    sessionStorage.removeItem(key); // consume-on-read
    const payload = JSON.parse(raw);
    if (!payload?.draft) return null;
    if (Date.now() - (payload.stashed_at || 0) > TTL_MS) return null;
    return payload;
  } catch (e) {
    try { sessionStorage.removeItem(key); } catch (_) { /* noop */ }
    return null;
  }
}

/** Route for a module's create page (used by the chat widget CTA). */
export const CREATE_ROUTES = {
  ptw: '/ptw/create',
  hira: '/hira/create',
  capa: '/capa/create',
};
